import React, { Fragment, useCallback, useState } from 'react';

import { useIntl } from 'react-intl-next';

import { IconButton } from '@atlaskit/button/new';
import BugIcon from '@atlaskit/icon/core/bug';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';
import { OnlineDebuggerModal } from './online-debugger-modal';

const ColoredBugIcon = () => <BugIcon color={token('color.icon.subtlest')} label="" />;

export const OnlineDebuggerButton = ({
	onClick,
}: {
	onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const [isSAINDebuggerModalOpen, setIsSAINDebuggerModalOpen] = useState(false);

	const openDebuggerModal = useCallback(
		(e: React.MouseEvent<HTMLButtonElement>) => {
			e.stopPropagation();
			onClick?.(e);
			setIsSAINDebuggerModalOpen(true);
		},
		[onClick],
	);
	const closeDebuggerModal = useCallback(() => setIsSAINDebuggerModalOpen(false), []);

	return (
		<Fragment>
			<IconButton
				icon={ColoredBugIcon}
				label={formatMessage(messages.ai_debugger_icon_label)}
				onClick={openDebuggerModal}
				appearance="subtle"
				isTooltipDisabled={false}
				spacing="compact"
				testId="sain-online-debugger-button"
				color={token('color.icon.subtlest')}
				shape="circle"
			/>

			<OnlineDebuggerModal isOpen={isSAINDebuggerModalOpen} onClose={closeDebuggerModal} />
		</Fragment>
	);
};
